import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { hasInAppHistory } from "web_myplann/Shared/Utils/backNavigation";

type Options = {
	alwaysUseDefaultRoute?: boolean;
	replaceOnBack?: boolean;
	backState?: unknown;
};

export const useNavigateBackOrDefault = (
	defaultRoute?: string,
	{
		alwaysUseDefaultRoute = false,
		replaceOnBack = false,
		backState,
	}: Options = {},
): (() => void) => {
	const navigate = useNavigate();
	const location = useLocation();

	return useCallback(() => {
		if (!defaultRoute) return;

		if (
			!alwaysUseDefaultRoute &&
			hasInAppHistory(location.key, window.history.length)
		) {
			navigate(-1);
			return;
		}

		navigate(defaultRoute, { replace: replaceOnBack, state: backState });
	}, [
		navigate,
		location.key,
		defaultRoute,
		alwaysUseDefaultRoute,
		replaceOnBack,
		backState,
	]);
};
